module.exports = new __parcel__URL__("java.ca3c8265.svg").toString();